import { render, staticRenderFns } from "./WalletStatementPartnerOwn.vue?vue&type=template&id=e26fdd84&scoped=true"
import script from "./WalletStatementPartnerOwn.vue?vue&type=script&lang=js"
export * from "./WalletStatementPartnerOwn.vue?vue&type=script&lang=js"
import style0 from "./WalletStatementPartnerOwn.vue?vue&type=style&index=0&id=e26fdd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26fdd84",
  null
  
)

export default component.exports